<template lang="pug">
  v-dialog(v-model='Product.dialog' max-width='800px')
    template(v-slot:activator='{ on }')
      v-btn(:class='existencia ? "mt-3 mx-2" : "mx-2 "' color='primary' rounded outlined v-on='on' @click='clearForm()') 
        span( v-if='!existencia') Agregar
        v-row( v-else justify='center' )
          v-icon(small) fa-box
          v-icon.ml-2( x-small ) fa-plus
    v-card
      v-card-title Registro
      v-card-text
        v-container
          v-row
            v-col
              v-autocomplete(v-model='data.codigo_producto_sunat' :items='productTypeRecord' :item-text='item=>`${item.codigo_producto_sunat} - ${item.descripcion}`' item-value='codigo_producto_sunat' label='Tipo de Producto')
            v-col
              v-select(v-model='data.unidad_de_medida' :items='tipo_unidad_de_medida' item-text='label' item-value='value' label='Unidad de medida')
              p(:v-html='data.nombre_unidad_de_medida = data.unidad_de_medida ? tipo_unidad_de_medida.filter(item=>item.value == data.unidad_de_medida)[0].label : ""')
          v-row  
            v-col( cols='3')
              v-text-field(v-model='data.codigo' label='Código')
            v-col( cols='6')
              v-combobox( v-model="data.descripcion" :return-object='false'  :item-text='item => `${item.codigo} ${item.descripcion} ${item.presentacion}`' label='Descripción' :items="productsRecord" item-value='descripcion')

            v-col( cols='3')
              v-text-field(v-model='data.presentacion' label='Presentación')
      v-card-actions
        v-spacer
        v-btn(color='primary' @click=' add()') Guardar
</template>
<script>
import tipo_unidad_de_medida from '@/jsons/tipo_de_unidad_de_medida.json'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data: ()=>({
    dialog: false,
    tipo_unidad_de_medida
  }),
  methods: {
    ...mapActions({
      add: 'Product/add',
      clearForm: 'Product/clearForm',
    }),

  },
  computed: {
    ...mapState({
      data: state=> state.Product.data,
      Product: state=> state.Product,
    }),
    ...mapGetters({
      productTypeRecord: 'ProductType/record',
      productsRecord: 'Product/record',
    })
  },
  props: {
    existencia: Boolean
  }
}
</script>